import {
  Flex,
  rem,
  rgba,
  Skeleton,
  Text,
  useMantineTheme,
} from "@mantine/core";

/**
 * Esqueleto de carregamento da aba Avançado (WebhookSettings). Mantém o texto
 * de ajuda fixo como elemento real e esqueletiza apenas as regiões dependentes
 * do setor: o toggle (ligado/desligado) e o formulário do webhook (URL salva).
 */
export function AdvancedTabSkeleton() {
  const theme = useMantineTheme();

  return (
    <Flex
      direction="column"
      gap={rem(16)}>
      <Text c={rgba(theme.colors["plain_text"][0], 0.8)}>
        Habilite o Webhook para integrar a plataforma com sua própria
        Inteligência Artificial. Você também precisará enviar a resposta gerada
        para o endpoint de respostas da plataforma.
      </Text>

      {/* Toggle do webhook — estado (ligado/desligado) vem do setor */}
      <Skeleton
        h={rem(24)}
        w={rem(160)}
        radius="xl"
      />

      {/* Formulário do webhook — URL salva vem do setor */}
      <Flex
        direction="column"
        gap={rem(8)}>
        <Skeleton
          h={rem(20)}
          w={rem(90)}
          radius="sm"
        />
        <Skeleton
          h={rem(16)}
          w={rem(320)}
          radius="sm"
        />
        <Skeleton
          h={rem(36)}
          w="65%"
          maw={rem(500)}
          radius="sm"
          mt={rem(16)}
        />
        <Skeleton
          h={rem(36)}
          w={rem(90)}
          radius="sm"
          mt={rem(16)}
        />
      </Flex>
    </Flex>
  );
}

export default AdvancedTabSkeleton;
